import { Avatar, Col, Row, Tag } from "antd";
import React, { useEffect, useRef, useState } from "react";
import "./staffPage.css";
import {
  AiOutlineCheckCircle,
  AiOutlineCloseCircle,
  AiOutlineUser,
} from "react-icons/ai";
import StyledContentCard from "../../components/styledComponent/styledContentCard";
import { useNavigate, useParams } from "react-router-dom";
import { ShowNotification } from "../../components/notification/notification";
import {
  disableStaff,
  enableStaff,
  getStaffDetails,
} from "../../server/staffServices";
import { StyledButton } from "../../components/styledComponent/styledElements";
import { FaUser, FaUserSlash } from "react-icons/fa";
import "./staffPage.css";
import { DisableEnableModal } from "../../components/styledComponent/deleteModal";
import StaffCreationModal from "./staffCreationModal";
import { Capitalize } from "../../utils/utils";
import { useAppContext } from "../../contexts/appContext";

function StaffDetails() {
  const { startLoading, stopLoading, user } = useAppContext();
  const { id } = useParams();
  const navigate = useNavigate();
  const formRef = useRef(null);
  const [staffData, setStaffData] = useState();
  const [refetch, setRefetch] = useState(false);
  const [activate, setActivate] = useState(false);
  const [showActivateDeactivate, setShowActivateDeactivate] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);

  const userRole = user?.role;
  const staffPermissions = user?.access?.staff;

  const fetchStaffDetails = async () => {
    startLoading();
    try {
      let res = await getStaffDetails(id);
      if (!res.data) {
        ShowNotification({ type: "error", message: "Staff not Found" });
        navigate("/staff");
      } else {
        setStaffData(res.data);
        setRefetch(false);
      }
    } catch (error) {
    } finally {
      stopLoading();
    }
  };
  useEffect(() => {
    fetchStaffDetails();
  }, [refetch]);
  const handleDeactivateStaff = () => {
    disableStaff(id)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Staff Disabled Successfully ",
        });
        setRefetch(true);
        setActivate(false);
      })
      .finally(() => {
        setShowActivateDeactivate(false);
      });
  };
  const handleActivateStaff = () => {
    enableStaff(id)
      .then(() => {
        ShowNotification({
          type: "success",
          message: "Staff Activated Successfully ",
        });
        setRefetch(true);
        setActivate(false);
      })
      .finally(() => {
        setShowActivateDeactivate(false);
      });
  };
  const PermissionGroup = ({ groupName, permissions }) => (
    <Col span={8} className="p-3">
      <h3 className="mb-1">{Capitalize(groupName)} Permissions</h3>
      <div className="flex gap-2">
        {Object.entries(permissions).map(([actionKey, actionValue]) => (
          <Tag
            className="flex items-center gap-2"
            icon={
              actionValue ? <AiOutlineCheckCircle /> : <AiOutlineCloseCircle />
            }
            color={actionValue ? "success" : "error"}
          >
            {actionKey.charAt(0).toUpperCase() + actionKey.slice(1)}
          </Tag>
        ))}
      </div>
    </Col>
  );
  const onClickEdit = () => {
    setShowUpdate(true);
  };
  return (
    <div>
      {showActivateDeactivate && (
        <DisableEnableModal
          showModal={showActivateDeactivate}
          title={staffData?.name}
          activate={activate}
          onCancel={() => {
            setShowActivateDeactivate(false);
            setActivate(false);
          }}
          onsubmit={activate ? handleActivateStaff : handleDeactivateStaff}
        />
      )}
      {showUpdate && (
        <StaffCreationModal
          showCreationModal={showUpdate}
          setShowCreationModal={setShowUpdate}
          formRef={formRef}
          updateId={id}
          setUpdateId={() => {}}
          setRefetch={setRefetch}
        />
      )}
      <StyledContentCard
        title={"Staff Details"}
        onClickEdit={onClickEdit}
        showEdit={userRole === "Admin" || staffPermissions?.edit}
      >
        <Row className="flex my-2" justify={"end"}>
          <Tag
            className="staff-status-tag"
            color={!staffData?.is_deactivated ? "success" : "error"}
          >
            {staffData && staffData.is_deactivated ? "Disabled" : "Active"}
          </Tag>
          {(userRole === "Admin" || staffPermissions?.edit) &&
            (!staffData?.is_deactivated ? (
              <StyledButton
                icon={<FaUserSlash />}
                danger
                background="#ededed"
                color="Black"
                border="White"
                height={32}
                onClick={() => {
                  setActivate(false);
                  setShowActivateDeactivate(true);
                }}
              />
            ) : (
              <StyledButton
                icon={<FaUser />}
                background="#ededed"
                color="green"
                border="White"
                height={32}
                onClick={() => {
                  setActivate(true);
                  setShowActivateDeactivate(true);
                }}
              />
            ))}
        </Row>
        <Row>
          <Col span={12} className="py-5">
            <Row className="mb-2">
              <Col span={12} className="details-key">
                Name:
              </Col>
              <Col span={12} className="details-value">
                {staffData && staffData?.name ? staffData.name : "-"}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col span={12} className="details-key">
                Contact Number:
              </Col>
              <Col span={12} className="details-value">
                {staffData && staffData.contact_no ? staffData.contact_no : "-"}{" "}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col span={12} className="details-key">
                Email Id:
              </Col>
              <Col span={12} className="details-value">
                {staffData && staffData.email ? staffData.email : "-"}
              </Col>
            </Row>
            <Row className="mb-2">
              <Col span={12} className="details-key">
                Address:
              </Col>
              <Col span={12} className="details-value">
                {staffData && staffData.address ? staffData.address : "-"}
              </Col>
            </Row>
          </Col>
          <Col span={12} className="flex justify-center py-5">
            <Avatar
              size={250}
              shape="square"
              icon={<AiOutlineUser />}
              style={{ backgroundColor: "#e9e9e9" }}
            />
          </Col>
          <Col span={24}>
            {staffData && (
              <StyledContentCard subTitle={"Permissions"}>
                <Row gutter={16}>
                  {staffData?.access &&
                    Object.entries(staffData?.access).map((val) => (
                      <PermissionGroup
                        groupName={val[0]}
                        permissions={val[1]}
                      />
                    ))}
                </Row>
              </StyledContentCard>
            )}
          </Col>
        </Row>
      </StyledContentCard>
    </div>
  );
}

export default StaffDetails;
